import Image from 'next/image'
import Logo from '@/public/images/logo.svg'

const AppLogo = () => (
  <>
    <Image
      src={Logo}
      alt="Hackathon"
      className="h-auto max-w-full cursor-pointer"
    />
    <div className="hidden flex-col lg:flex cursor-pointer">
      <span className="text-lg font-bold text-gray-800">Hackathon</span>
      <span className="text-sm font-semibold text-gray-400">By AngelHack</span>
    </div>
  </>
)
export default AppLogo
